<template>
  <div class="responsive-action-col">
    <router-link
        :to="`/online-factor/discounts/${row.id}/details`"
        class="btn btn-sm btn-clean btn-icon btn-icon-sm"
    >
      <i class="fas fa-eye"></i>
    </router-link>
    <a type="button" @click="deleteitem(row)" class="btn btn-sm btn-clean btn-icon btn-icon-sm">
      <i class="fas fa-trash"></i>
    </a>
  </div>
</template>


<script>

import Vue from "vue";
import toastr from "toastr";
import { onlineFactorService } from '@/common/shop.service'



export default Vue.extend({
  props: {
    row: {
      required: true,
    },
    index: {
      required: true,
    },
    datatable: {
      required: true,
    }
  },
  computed : {
    toastr() {
      toastr.options = {
        closeButton: true,
        positionClass: "toast-bottom-center",
        preventDuplicates: true,
        rtl: false
      }

      return toastr
    }
  },

  methods:{
    deleteitem() {
      onlineFactorService.deleteDiscount(this.row.id).then((response) => {
        this.toastr.success(response.data.message)
        this.datatable.reload()
      }).catch(({response}) => {
        this.toastr.error(response.data.message)
      })
    }
  },

})

</script>

<style scoped>

</style>
